import React from "react"

function Toolbox({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.5 19.6665V22.9998C25.5 23.4601 25.1269 23.8332 24.6667 23.8332H11.3333C10.8731 23.8332 10.5 23.4601 10.5 22.9998V19.6665M25.5 19.6665V17.1665C25.5 16.246 24.7538 15.4998 23.8333 15.4998H21.3333M25.5 19.6665H22.1667M10.5 19.6665V17.1665C10.5 16.246 11.2462 15.4998 12.1667 15.4998H14.6667M10.5 19.6665H13.8333M21.3333 15.4998V13.8332C21.3333 12.9127 20.5872 12.1665 19.6667 12.1665H16.3333C15.4129 12.1665 14.6667 12.9127 14.6667 13.8332V15.4998M21.3333 15.4998H14.6667M22.1667 19.6665H13.8333M22.1667 19.6665V20.4998V18.8332M13.8333 19.6665V18.8332M13.8333 19.6665V20.4998"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Toolbox
